import React from 'react';
import { motion } from 'framer-motion';
import { Coins } from 'lucide-react';

const CoinsDisplay = ({ coins = 0 }) => {
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className="flex items-center gap-2 "
      data-testid="coins-display"
    >
      <Coins className="w-5 h-5 text-warning" fill="currentColor" />
      <span className="text-xl font-heading font-bold text-text-primary">{coins}</span>
    </motion.div>
  );
};

export default CoinsDisplay;